import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Accordion/accordion.mjs';
export const AccordionExpandableContentBody = (_a) => {
    var { children = null } = _a, props = __rest(_a, ["children"]);
    return (_jsx("div", Object.assign({ className: css(styles.accordionExpandableContentBody) }, props, { children: children })));
};
AccordionExpandableContentBody.displayName = 'AccordionExpandableContentBody';
//# sourceMappingURL=AccordionExpandableContentBody.js.map